import { Shield, Lock, Brain, ArrowRight } from "lucide-react";
import { Link } from "wouter";

export function TrustSecurity() {
  return (
    <section id="trust" className="py-24 border-b border-border/40 bg-accent/10">
      <div className="container mx-auto px-6">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-6">
            Built on Trust
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            We prioritize your trust and privacy above all else. Our tools are designed with you in mind, and safeguarding your information remains central to our values.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-12 mb-24">
          <div className="text-center flex flex-col items-center">
            <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center rounded-none bg-primary/10">
              <Lock className="w-8 h-8 text-primary" />
            </div>
            <h3 className="text-2xl font-bold mb-3">Privacy</h3>
            <p className="text-muted-foreground mb-4">
              We mind our business. Not yours.
            </p>
            <p className="text-sm text-muted-foreground">
              Explore the measures we implement to secure data and ensure the protection of your information.
            </p>
            <Link href="/trust-privacy" aria-label="Learn more about HarmCheck privacy practices" className="mt-6 inline-flex items-center text-primary-text font-medium text-base hover:underline group">
              Learn more about privacy
              <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
          <div className="text-center flex flex-col items-center">
            <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center rounded-none bg-primary/10">
              <Shield className="w-8 h-8 text-primary" />
            </div>
            <h3 className="text-2xl font-bold mb-3">Security</h3>
            <p className="text-muted-foreground mb-4">
              Industry standard security infrastructure.
            </p>
            <p className="text-sm text-muted-foreground">
              Backed by SOC 2, CCPA, ISO/IEC 27018:2019, ISO/IEC 27017:2015, FERPA, and PCI DSS — learn how we strengthen our products.
            </p>
            <Link href="/trust-security" aria-label="Learn more about HarmCheck security infrastructure" className="mt-6 inline-flex items-center text-primary-text font-medium text-base hover:underline group">
              Learn more about security
              <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
          <div className="text-center flex flex-col items-center">
            <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center rounded-none bg-primary/10">
              <Brain className="w-8 h-8 text-primary" />
            </div>
            <h3 className="text-2xl font-bold mb-3">Responsible AI</h3>
            <p className="text-muted-foreground mb-4">
              A commitment to helpful and responsible AI.
            </p>
            <p className="text-sm text-muted-foreground">
              Learn how we conscientiously develop Alphy’s technology to benefit and help all.
            </p>
            <Link href="/trust-responsible-ai" aria-label="Learn more about HarmCheck's responsible AI commitment" className="mt-6 inline-flex items-center text-primary-text font-medium text-base hover:underline group">
              Learn more about responsible AI
              <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>

      </div>
    </section>
  );
}
